import { useLocation } from "react-router-dom";

interface SocialShareProps {
  title: string;
  // Kept for call-site compatibility; only the URL and title are used to share.
  description?: string;
  imageUrl?: string;
}

const SITE_URL = "https://gazar.dev";

const SocialShare = ({ title }: SocialShareProps) => {
  const location = useLocation();
  const currentUrl = `${SITE_URL}${location.pathname}${location.search}`;

  const encodedUrl = encodeURIComponent(currentUrl);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
  };

  const handleShare = (platform: keyof typeof shareLinks) => {
    window.open(shareLinks[platform], "_blank", "width=600,height=400,scrollbars=yes,resizable=yes");
  };

  const buttonBase = "flex items-center justify-center w-9 h-9 rounded-full text-gray-50 transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-2";

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs font-semibold text-gray-500 uppercase tracking-widest mr-1 font-heading">Share</span>

      <button
        onClick={() => handleShare("twitter")}
        className={`${buttonBase} bg-[#1DA1F2] hover:bg-[#1a8cd8] focus:ring-[#1DA1F2]`}
        aria-label="Share on X (Twitter)"
        title="Share on X"
      >
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      </button>

      <button
        onClick={() => handleShare("linkedin")}
        className={`${buttonBase} bg-[#0077B5] hover:bg-[#006399] focus:ring-[#0077B5]`}
        aria-label="Share on LinkedIn"
        title="Share on LinkedIn"
      >
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
      </button>
    </div>
  );
};

export default SocialShare;
